﻿import React from 'react';
import {LocationAllReportingVO} from "../../../types/model/valueObject/LocationAllReportingVO";
import {AdminLocationsCardListItem} from "./AdminLocationsCardListItem";
import {withLoader} from "../../hocs/withLoader";
import {LocationCardSkeleton} from "../../common/reports/loadingSkeletons/LocationCardSkeleton";

type AdminLocationsCardListProps = {
  items?: LocationAllReportingVO[];
  expandByIndex: Array<boolean>;
  onToggleExpand: (index: number) => void;
}

const AdminLocationsCardList = ({
  items,
  expandByIndex,
  onToggleExpand
}: AdminLocationsCardListProps) => {
  if (!items?.length) {
    return null;
  }

  return  <>
    {
      items.map((item, index) => (
        <AdminLocationsCardListItem
          key={item?.locationId}
          item={item}
          expanded={expandByIndex[index]}
          onToggleExpand={() => onToggleExpand(index)}
        />
      ))
    }
  </>
}

const skeletonLoader = () => Array.from({ length: 10 }).map((_, index) => (
  <LocationCardSkeleton key={index} />
));

const AdminLocationsCardListWithLoader = withLoader(AdminLocationsCardList, skeletonLoader);

export {
  AdminLocationsCardList,
  AdminLocationsCardListWithLoader
};
